import httpClient from "./httpClient/api";

const sendMessage = (data) => httpClient.post("/contact", data);

export default {
  sendMessage
}